var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.healthData.id)?_c('stacked-bar-chart',{key:_vm.healthData.id,attrs:{"graphdata":_vm.healthData,"legend":false,"total":_vm.total,"only-percent":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }